import { takeLatest, call, put, all } from "redux-saga/effects";
import { toast } from "react-toastify";

import history from "~/services/history";
import api from "~/services/api";

import {
  saveLr1Failure,
  saveLr1Success,
  updateLr1Failure,
  updateLr1Success
} from "./actions";

export function* saveLr1({ payload }) {
  try {
    yield call(api.post, "api/lr1", payload.data, { withCredentials: true });

    yield put(saveLr1Success());

    toast.success("Lr1 criado com sucesso!");

    history.push("/specifications/pilar3/resources/lr1");
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveLr1Failure());
  }
}

export function* updateLr1({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/lr1/${id}`, payload.data, { withCredentials: true });

    yield put(updateLr1Success());

    toast.success("Lr1 atualizado com sucesso!");

    history.push("/specifications/pilar3/resources/lr1");
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateLr1Failure());
  }
}

export default all([
  takeLatest("@lr1/SAVE_REQUEST", saveLr1),
  takeLatest("@lr1/UPDATE_REQUEST", updateLr1)
]);
